export default "__VITE_ASSET__H8k7KlYu__"